<template>
  <div v-if="post">
        <Article
        :page_title="post.title.rendered"
        :meta_title="(post.custom_fields.meta_title)?(post.custom_fields.meta_title):(post.title.rendered + ' | umzug-bayern.com')"
        :keywords="(post.custom_fields.meta_keywords)?(post.custom_fields.meta_keywords):(['Umzug München', 'Umzugsunternehmen München', 'Umzugshelfer'])"
        :description="(post.custom_fields.meta_description)?(post.custom_fields.meta_description):(post.title.rendered + ' | umzug-bayern.com')"
        :is_card="false"
        :bg_image="(post._embedded['wp:featuredmedia'].length > 0)?post._embedded['wp:featuredmedia'][0].source_url:null"
        >
        <SchemaOrgArticle v-if="post != null"
        :headline="post.title.rendered"
        :description="post.excerpt.rendered"
        :date_published="post.date"
        :date_modified="post.modified"
        :slug_url="$route.fullPath"
        :image_url="(post._embedded['wp:featuredmedia'].length > 0)?post._embedded['wp:featuredmedia'][0].source_url:null"
        :image_width="(post._embedded['wp:featuredmedia'].length > 0)?post._embedded['wp:featuredmedia'][0].media_details.width.toString():null"
        :image_height="(post._embedded['wp:featuredmedia'].length > 0)?post._embedded['wp:featuredmedia'][0].media_details.height.toString():null"
        />
        <div class="bg-light py-4">
          <div class="container">
            <div v-html="post.content.rendered">

            </div>
          </div>
        </div>
          </Article>
  </div>

</template>

<script>
import Article from '@/components/Article.vue'
import SchemaOrgArticle from '@/components/schema-org/SchemaOrgArticle.vue'
export default {
  name: 'BlogPostView',
  components: {
    Article,
    SchemaOrgArticle
  },
  data: function() {
    return {
      post: null
    }
  },
  mounted: function() {
    if(this.$route.params.slug !== undefined) {
      this.CmsApi.GetArticleBySlug(this.$route.params.slug).then((data) => {
        if(data != null && data != [] && data.length != 0) {

          if(data.length == 1) {
            this.post = data[0]
          }
        } else {
          this.$router.push({ name: 'notfound' })
        }
      }).catch(() => {
        // console.log(slug)
      })
    }


  }
}
</script>
